import React from 'react';
import { ChatBubbleLeftRightIcon } from '@heroicons/react/24/outline';

const LoginPage = () => {
  const CLIENT_ID = process.env.REACT_APP_BASALAM_CLIENT_ID;
  const REDIRECT_URI = process.env.REACT_APP_BASALAM_REDIRECT_URI || 'http://pricewatch.local:3000/auth/callback';
  const CLIENT_NAME = process.env.REACT_APP_BASALAM_CLIENT_NAME || 'price-watch-local';

  const scopes = [
    'vendor.profile.read',
    'vendor.product.read',
    'vendor.parcel.read',
    'customer.chat.read',
    'customer.chat.write'
  ];

  const handleBasalamLogin = () => {
    const authUrl = `https://basalam.com/accounts/sso?client_id=${CLIENT_ID}&scope=${scopes.join('%20')}&redirect_uri=${encodeURIComponent(REDIRECT_URI)}&state=${encodeURIComponent(CLIENT_NAME)}`;
    window.location.href = authUrl;
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-purple-400 via-purple-300 to-blue-300 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full">
        {/* کارت اصلی */}
        <div className="bg-white rounded-2xl shadow-2xl px-8 py-10">
          {/* آیکون */}
          <div className="flex justify-center mb-6">
            <div className="w-20 h-20 bg-gradient-to-br from-purple-500 to-blue-500 rounded-full flex items-center justify-center shadow-lg">
              <ChatBubbleLeftRightIcon className="h-10 w-10 text-white" />
            </div>
          </div>

          {/* عنوان */}
          <h1 className="text-center text-3xl font-bold text-gray-800 mb-2">
            خوش آمدید
          </h1>

          {/* توضیح */}
          <p className="text-center text-gray-500 mb-8">
            دستیار هوشمند فروش باسلام
          </p>

          {/* دکمه ورود با باسلام */}
          <button
            onClick={handleBasalamLogin}
            className="w-full bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white font-bold py-4 px-6 rounded-xl shadow-lg transform transition-all duration-200 hover:scale-105 flex items-center justify-center gap-3"
          >
            <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
            </svg>
            ادامه با باسلام
          </button>

          {/* توضیح امنیت OAuth */}
          <div className="mt-6 flex items-center justify-center gap-2 text-xs text-gray-400">
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
            </svg>
            <span>امن OAuth 2.0</span>
          </div>

          {/* Privacy Note */}
          <p className="mt-8 text-center text-xs text-gray-500 leading-relaxed">
            با ورود، شما با{' '}
            <a href="#" className="text-purple-600 hover:text-purple-700">
              شرایط خدمات
            </a>
            {' '}و{' '}
            <a href="#" className="text-purple-600 hover:text-purple-700">
              سیاست حریم خصوصی
            </a>
            {' '}باسلام موافقت می‌کنید
          </p>
        </div>

        {/* لینک راهنما */}
        <div className="mt-6 text-center">
          <a
            href="#"
            className="text-white text-sm hover:text-purple-100 transition-colors"
          >
            نیاز به راهنمایی دارید؟{' '}
            <span className="underline">مشاهده راهنمای ورود</span>
          </a>
        </div>

        {/* Footer */}
        <div className="mt-8 text-center text-white text-xs opacity-75">
          بازگشت به صفحه اصلی
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
